<div class="bh-common-page-progress-main">
  <div class="my-2 mt-lg-4">
    <ion-text class="font-14 weight-500 mb-2 mt-lg-2 text-center d-block text-uppercase"
      color="medium">{{loadingText}}</ion-text>
    <div class="progress-indicator-container mx-auto">
      <span class="loader"></span>
    </div>
  </div>
</div>